import { render, staticRenderFns } from "./PublishingContractsSubCataloguesWorksEditPanelDialog.vue?vue&type=template&id=55c9eb3e"
import script from "./PublishingContractsSubCataloguesWorksEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSubCataloguesWorksEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports